import { create } from "@mui/material/styles/createTransitions"
import { createContext, useState, useMemo } from "react"

export const PaymentContext = createContext(null)

function PaymentContextProvider(props) {
  const [rowData, setRowData] = useState([])

  const contextValue = useMemo(
    () => ({
      rowData,
      setRowData,
    }),
    [ rowData]
  )

  // const contextValue = {
  //   rowData,
  //   setRowData,
  // }
  return (
    <PaymentContext.Provider value={contextValue}>
      {props.children}
    </PaymentContext.Provider>
  )
}

export default PaymentContextProvider
